var styles = {"article":"CommonHeader-module_article__sFY73","inner":"CommonHeader-module_inner__CNjq5","aside-right":"CommonHeader-module_aside-right__auJsW","aside-left":"CommonHeader-module_aside-left__HwtmV","left":"CommonHeader-module_left__lnT7u","center":"CommonHeader-module_center__u4MM2"};

export { styles as default };
